import React, { Component } from "react";
import RbLabel, { LabelSize } from "../../bosch-react/components/label/RbLabel";

type Props = {
  date: string; // The input date string
};

type State = {};

class DateTimeDisplay extends Component<Props, State> {
  // Function to format the date
  formatDateTime(dateString: string): string {
    const date = new Date(dateString);

    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // Use 12-hour format
    }).format(date);
  }

  render() {
    const { date } = this.props;

    return (
        <RbLabel size={LabelSize.Small}>
        {/* Call the formatDateTime function to display the formatted date */}
        {this.formatDateTime(date)}
      </RbLabel>
    );
  }
}

export default DateTimeDisplay;
